module.exports = __webpack_public_path__ + "static/origin-fulfillment-fa4427122fb2f101d372517a2e5f7581.png";